
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M8.097 5.505c-.103-1.346-.73-2.19-1.282-2.933-.512-.69-.954-1.284-.954-2.161a.188.188 0 00-.297-.153c-.83.594-1.523 1.595-1.765 2.55-.168.665-.19 1.412-.193 1.906-.767-.164-.94-1.31-.942-1.323a.189.189 0 00-.268-.142c-.04.02-.987.5-1.042 2.42a3.387 3.387 0 003.38 3.575H4.742a3.387 3.387 0 003.374-3.383c0-.094-.02-.356-.02-.356zM4.733 8.868c-.622 0-1.127-.539-1.127-1.201l.001-.073c.008-.28.06-.47.119-.597.109.234.304.45.62.45a.188.188 0 00.188-.189c0-.267.006-.576.073-.855.059-.247.2-.51.38-.72.08.273.236.495.388.71.217.31.442.63.481 1.174.003.033.005.065.005.1 0 .662-.506 1.201-1.128 1.201z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.222 .222)","d":"M0 0h9.022v9.022H0z"}})])])])
          )
        }
      }
    